import { MLY_IDS, mlyLabels } from "../constants/constant";
import { FormValues } from "../Interface/scheduler/form";

export function handlePropertyDetails(
  formValues: FormValues,
  notesArray: string[]
) {
  notesArray.push(
    `${mlyLabels.SQ_FT}: {${formValues[MLY_IDS.MLY_HOME_PROPERTY_SQ_FT]}}`,
    `${mlyLabels.BEDROOMS}: {${formValues[MLY_IDS.MLY_RES_BEEDROOMS]}}`,
    `${mlyLabels.BATHROOMS}: {${formValues[MLY_IDS.MLY_RES_BATHROOMS]}}`
  );
}

export function handleCommercialPropertyDetails(
  formValues: FormValues,
  notesArray: string[]
) {
  notesArray.push(
    `${mlyLabels.SQ_FT}: {${formValues[MLY_IDS.MLY_OFFICE_PROPERTY_SQ_FT]}}`,
    `${mlyLabels.OFFICES}: {${formValues[MLY_IDS.MLY_COM_OFFICES]}}`,
    `${mlyLabels.BATHROOMS}: {${formValues[MLY_IDS.MLY_COM_BATHROOMS]}}`
  );
}

export function handleMLYResidential(
  formValues: FormValues,
  notesArray: string[]
) {
  if (formValues[MLY_IDS.FREQUENCY] === MLY_IDS.ONE_TIME_CLEAN) {
    if (
      formValues[MLY_IDS.ONE_TIME_CLEAN_ID] === MLY_IDS.ONE_TIME_CLEAN_OPTION
    ) {
      notesArray.push(MLY_IDS.NOT_MOVE_IN_OUT_CLEAN);
    } else {
      notesArray.push(MLY_IDS.MOVE_IN_OUT_CLEAN);
    }
    if (formValues.mlyEstimate && !formValues.mlyEstimate?.includes("$0"))
      notesArray.push(`${mlyLabels.MLY_PRICE}: ${formValues?.mlyEstimate}`);
    if (formValues?.hideMLYEstimateSection)
      notesArray.push(MLY_IDS.NO_CALENDAR_PRICING);
    handlePropertyDetails(formValues, notesArray);
  }
}

export function addFrequencyNote(frequencyValue: string, notesArray: string[]) {
  const freq = frequencyValue?.includes("recurring")
    ? MLY_IDS.RECURRING
    : MLY_IDS.ONE_TIME;
  const freqNote = `${mlyLabels.FREQUENCY}: ${freq}`;
  notesArray.push(freqNote);
}
